// Enum metadata + formatters for incident reports. Single source of truth.

import {
  FirstAid,
  Thermometer,
  UsersThree,
  Warning,
  Pill,
  Package,
  Info,
} from "@phosphor-icons/react";

export const INCIDENT_TYPES = [
  "injury",
  "illness",
  "behavior",
  "allergic_reaction",
  "medication",
  "property",
  "other",
];

export const INCIDENT_TYPE_META = {
  injury:            { label: "Injury",            icon: FirstAid,    color: "text-[#C6851E]", bg: "bg-[#C6851E]/10" },
  illness:           { label: "Illness",           icon: Thermometer, color: "text-[#C6851E]", bg: "bg-[#C6851E]/10" },
  behavior:          { label: "Behavior",          icon: UsersThree,  color: "text-[#4A4E56]", bg: "bg-neutral-100" },
  allergic_reaction: { label: "Allergic reaction", icon: Warning,     color: "text-[#C6851E]", bg: "bg-[#C6851E]/10" },
  medication:        { label: "Medication",        icon: Pill,        color: "text-[#5A7E46]", bg: "bg-primary/10" },
  property:          { label: "Property",          icon: Package,     color: "text-[#4A4E56]", bg: "bg-neutral-100" },
  other:             { label: "Other",             icon: Info,        color: "text-neutral-700", bg: "bg-neutral-100" },
};

export const SEVERITIES = ["low", "medium", "high"];
export const SEVERITY_META = {
  low:    { label: "Low",    color: "text-primary-hover", bg: "bg-primary/10",  ring: "border-primary/30" },
  medium: { label: "Medium", color: "text-[#4A4E56]",     bg: "bg-secondary/30", ring: "border-secondary/50" },
  high:   { label: "High",   color: "text-[#C6851E]",     bg: "bg-[#C6851E]/10", ring: "border-[#C6851E]/40" },
};

export const STATUSES = ["submitted", "acknowledged", "resolved", "void"];
export const STATUS_META = {
  submitted:    { label: "Submitted",    color: "text-neutral-700",   bg: "bg-neutral-100" },
  acknowledged: { label: "Acknowledged", color: "text-primary-hover", bg: "bg-primary/10" },
  resolved:     { label: "Resolved",     color: "text-[#4A4E56]",     bg: "bg-neutral-100" },
  void:         { label: "Void",         color: "text-neutral-500",   bg: "bg-neutral-100" },
};

export const NOTIFICATION_METHODS = ["in_person", "phone", "message", "email"];
export const NOTIFICATION_METHOD_LABELS = {
  in_person: "In person",
  phone: "Phone call",
  message: "App message",
  email: "Email",
};

export function formatIncidentDateTime(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return `${d.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  })} · ${d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}`;
}

export function formatIncidentDate(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return d.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

/** For <input type="datetime-local"> initial value. */
export function toLocalDateTimeInput(iso) {
  const d = iso ? new Date(iso) : new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
